import { useCallback } from 'react'
import { defineMessages, MessageDescriptor, useIntl } from 'react-intl'

import { CareTeamSlot } from '../../../../episodes/data/episodesApi'

const careTeamSlotLabels: Record<string, MessageDescriptor> = defineMessages({
  NP_INTAKE_COORDINATOR: {
    defaultMessage: 'Neuropsych Intake Coordinator',
    description: 'Care team role label for the neuropsych intake coordinator',
  },
  NP_EVALUATION_PSYCHOLOGIST: {
    defaultMessage: 'Neuropsych Evaluation Psychologist',
    description: 'Care team role label for the neuropsych evaluation psychologist',
  },
  NP_TESTER: {
    defaultMessage: 'Neuropsych Tester',
    description: 'Care team role label for the neuropsych tester',
  },
  NP_ALTERNATE_TESTER: {
    defaultMessage: 'Alternate Neuropsych Tester',
    description: 'Care team role label for the alternate neuropsych tester',
  },
  NP_CARE_COORDINATOR: {
    defaultMessage: 'Care Coordinator',
    description: 'Care team role label for the care coordinator',
  },
  NP_TESTING_LOGISTICS: {
    defaultMessage: 'Testing Logistics',
    description: 'Care team role label for testing logistics',
  },
  NP_ADDITIONAL_SUPPORT: {
    defaultMessage: 'Additional Support',
    description: 'Care team role label for additional support providers',
  },
})

export const useCareTeamSlotLabel = () => {
  const intl = useIntl()

  return useCallback(
    ({ care_team_slot, display_name }: Pick<CareTeamSlot, 'care_team_slot' | 'display_name'>): string => {
      const message: MessageDescriptor | undefined = careTeamSlotLabels[care_team_slot]
      return message ? intl.formatMessage(message) : display_name
    },
    [intl],
  )
}
